<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
		<div class="row">
			<div class="col-md-12 search form minimize"> 
			
				<form class="search fuel formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
						<div class="col-md-3 form-group">
							<ReportParamSelect title="Station" name="detail1" v-model="detail1" :options="options.detail1" />
						</div>
						<div class="col-md-9 form-group">
							<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />
						</div>
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Owner" name="owner" v-model="owner" :options="options.owner" />
						</div>
						<div class="col-md-4 form-group">
							<ReportParamSelect title="Tol" name="lokasi" v-model="lokasi" :options="options.lokasi" />
						</div>
					</div>
					<div class="row" v-show="tabIndex != 3">
						<div class="col-md-6 form-group">
							<ReportParamDateRange title="Date" v-model="date" />
						</div>
						<div class="col-md-6 form-group">
							<ReportParamSelect title="Periods" name="period" v-model="period" :options="options.period" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 form-group" v-show="tabIndex != 2">
							<ReportParamSelect title="Products" name="detail2" v-model="detail2" :options="options.detail2" />
						</div>
						<div class="col-md-6 form-group" v-show="tabIndex == 2">
							<ReportParamSelect title="Payment" name="detail3" v-model="detail3" :options="options.detail3" />
						</div>
						<div class="col-md-6 form-group" v-show="tabIndex == 3">
							<ReportParamSelect title="Status" name="status" v-model="status" :options="options.status" />
						</div>

						<div class="col-md-6 form-group">
							<ReportParamSelect title="Type" name="type" v-model="stationtype" :options="options.types" />
						</div>

					</div>

				</form>
			</div> 
		</div> 
		<div class="row" v-if="tabIndex==0">
			<div class="col-md-6"><input type="checkbox" v-model="showchart"> Show Chart </div>
			<div class="col-md-6" v-if="showchart"><input type="checkbox" v-model="stacked"> Stacked </div>
		</div> 
		<LineChart :data="chartdata" :width="500" :height="280" v-if="showchart && tabIndex==0" />
	
		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="FuelReport" :reportdata="reportdata" :reporturl="urlRequestParams"/>
					<Loader :loading="this.loading.table" :customclass="''" class="child"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import LineChart from '@/components/chart/BarChart.js'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'


export default
{
	extends:Fuel,
	components: {
		LineChart,
		ReportParamSelect,
		ReportResultTable,
		ReportParamSearch,
		ReportParamDateRange,
		Loader,
	},
	data() {
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "station", name: "BY STATION" }, 
					//{ value: "tank", name: "BY TANK" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "ProductGroup" }, 
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				detail3:[
					{ value: "", name: "ALL" }, 
					{ value: "cash", name: "BY CASH" }, 
					{ value: "payment", name: "BY METHOD" },
				],
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				lokasi:[
					{ value: "", name: "ALL" }, 
					{ value: "TOL", name: "TOL" }, 
					{ value: "NON TOL", name: "NON TOL" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "NORMAL", name: "NORMAL" }, 
					{ value: "LOW", name: "LOW" }, 
					{ value: "CRITICAL", name: "CRITICAL" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					//{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
				],
			},
			tabList:[
				{name:'Sales'},
				{name:'Losses'},
				{name:'Payment'},
				{name:'Stock'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : 'product',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : 'area',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',
		}
	},

	watch:
	{
		tabIndex() { 
			if(this.tabIndex == 3) {
				let tankFilter = { value: "tank", name: "BY TANK" };
				this.options.detail1.push(tankFilter);
			}
			
			if(this.tabIndex < 3) {
				this.detail1 = "";
				let detailArray1 = this.options.detail1
				for(let idx=0; idx<detailArray1.length; idx++) {
					if(detailArray1[idx].value == 'tank') {
						this.options.detail1.splice(idx,1);
						//this.options.detail1.splice(-1);
					}
				}
			}

			this.resumePilihan() 
		},
		date(){ this.resumePilihan() },
		plantno() { this.resumePilihan() },
		stationid() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
		stationtype(){ this.resumePilihan() },

		
	},      
	mounted(){
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
		document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		this.$emit('childrenRoute')
		
		this.loadStationList()
		this.resumePilihan()
	},
	methods:{

		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""
			
			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a
			
			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1000, 2, c, false, false, false, this.stacked);
		},
		
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		
		async resumePilihan(){

			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/fuel2/sales?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/fuel2/losses?'
			else if (this.tabIndex == 2) this.urlRequestParams+='/fuel2/payment?'
			else if (this.tabIndex == 3) this.urlRequestParams+='/fuel2/stock?'

			this.urlRequestParams+='&date-range-start='+this.date.Start
			this.urlRequestParams+='&date-range-end='+this.date.End
			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&plant='+this.plantno
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&lokasi='+this.lokasi
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&satgas='+this.satgas
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})

        },

		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		}
	}
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.75) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }
    

.search.form { background:#f8f9fa; border-radius:0px 0px 5px 5px; color:#666; padding:20px; transition: all 0.5s ease-in-out;}
.search.form.minimize{ padding:0px; height:2px; overflow:hidden; }
.search.form.floating {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 750px;
    height: 300px;
    z-index: 9;
    background: rgba(172,196,55,.75);
    padding: 20px;
    border-radius: 15px 15px 0px 15px;
    overflow-Y: scroll;
    }
    .table .card .card-header{ display:none;}
    .table .card .card-body{ padding: 0px;}
    .table.pdf{ border:0px; }
    .table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
    .table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }
    
    .table.pdf thead tr{ background: #ccc; color:#333;}
 

    .filter .icon-up { display: flex; }
    .filter.down .icon-up { display: none; }
    .filter .icon-down { display: none; }
    .filter.down .icon-down { display: flex; }


</style>